'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userJobEdit = require('./user-job-edit.html');

var _userJobEdit2 = _interopRequireDefault(_userJobEdit);

var _userJobEdit3 = require('./user-job-edit.controller');

var _userJobEdit4 = _interopRequireDefault(_userJobEdit3);

require('./user-job-edit.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userJobEditComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template: _userJobEdit2.default,
  controller: _userJobEdit4.default,
  controllerAs: 'vm'
};

exports.default = userJobEditComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-job-edit/user-job-edit.component.js
 **/